export default function () {
  this.loadModalities()
}
